import { MAX_RESUME_DELTA_MS } from './constants';
import { EngineState } from './types';

export const resumeEngineClock = (engine: EngineState, pausedAtMs: number | null, nowMs: number) => {
  if (pausedAtMs === null || nowMs <= pausedAtMs) {
    return;
  }

  const pausedDurationMs = nowMs - pausedAtMs;
  engine.phaseStartedAtMs += pausedDurationMs;
  if (engine.chargeStartedAtMs !== null) {
    engine.chargeStartedAtMs += pausedDurationMs;
  }
};

export const getBoundedFrameDelta = (deltaMs: number) =>
  Math.max(0, Math.min(MAX_RESUME_DELTA_MS, deltaMs));
